<template lang="pug">
  div
    Header
    v-content
      v-container
        v-layout(justify="center")
          v-flex(xs8)
            h1 Избранное
            AdvertsListItem(:advertItem="item", v-for="(item, index) in favoriteList", :key="index")
</template>

<script>
export default {
  components: {
    Header: () => import('../components/Header'),
    AdvertsListItem: () => import('../components/Adverts/AdvertsListItem')
  },
  created() {
    this.$store.dispatch('GET_FAVORITE_LIST')
  },
  computed: {
    favoriteList() {
      return this.$store.state.favorites.favoriteList
    }
  }
}
</script>
